module.exports = __webpack_public_path__ + "img/close-normal.08ab0e71.svg";